import React, {useState} from 'react';
import PropTypes from 'prop-types';

/**
 * For objects that need pagination but don't want to store pagination params in the URL
 * (i.e. inside a modal dialog on a page that already has other paginated elements using the URL)
 *
 * @param WrappedComponent
 * @returns {function(*): *}
 */
const withStateBasedPagination = (WrappedComponent) => {
  const PaginatedComponent = (props) => {
    const [page, setPage] = useState(1);

    return <WrappedComponent {...props} page={page} setPage={setPage} />;
  };

  PaginatedComponent.propTypes = {
  };

  return PaginatedComponent;
};

withStateBasedPagination.propTypes = {
  WrappedComponent: PropTypes.element
};

export default withStateBasedPagination;
